import { useAgreementDetailDispatch } from './agreement-detail-context';
import PortalAppService from '../../../application/platform/portal-app-service';

export function useAgreementDetailController() {
  const dispatch = useAgreementDetailDispatch();

  const loadDetail = async (id: number) => {
    dispatch({ type: 'LOAD_START' });
    try {
      const response = await PortalAppService.requestAgreementDetail(id);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: 'LOAD_ERROR', payload: 'Erro ao carregar detalhes do convênio/repasse.' });
    }
  };

  return { loadDetail };
}
